import { render, staticRenderFns } from "./MemberDocuments.vue?vue&type=template&id=3f02c89f&"
import script from "./MemberDocuments.vue?vue&type=script&lang=js&"
export * from "./MemberDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f02c89f')) {
      api.createRecord('3f02c89f', component.options)
    } else {
      api.reload('3f02c89f', component.options)
    }
    module.hot.accept("./MemberDocuments.vue?vue&type=template&id=3f02c89f&", function () {
      api.rerender('3f02c89f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/fuel-resources/MemberDocuments.vue"
export default component.exports